import { render } from "./login_acceso.vue?vue&type=template&id=81b76704&scoped=true"
import script from "./login_acceso.vue?vue&type=script&lang=js"
export * from "./login_acceso.vue?vue&type=script&lang=js"

import "./login_acceso.vue?vue&type=style&index=0&id=81b76704&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81b76704"]])

export default __exports__